import PropTypes from 'prop-types';
import React from 'react';
import { defaultProps } from 'recompose';

import BackButton from '@/components/BackButton';
import Breadcrumbs from '@/components/Breadcrumbs';
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import { ROUTE_PATH as MERCHANTS_PATH } from '@/features/merchantsPage/consts';

import FormCreate from './Form';

const Form = defaultProps({
  company: '',
  identification_number: '',
  legal_address: '',
  partnership_start_date: null,
  partnership_agreement: '',
  submitButtonText: 'Создать',
})(FormCreate);

const NewMerchant = ({ createMerchant }) => (
  <Page>
    <PageHeader borderBottom gutterBottom={false}>
      <Breadcrumbs>
        <Breadcrumb to={MERCHANTS_PATH}>Арендаторы</Breadcrumb>
      </Breadcrumbs>
      <BackButton />
      <PageTitle>Создать арендатора</PageTitle>
    </PageHeader>

    <PageContent xl={8}>
      <PaperSheet>
        <Form onSubmit={createMerchant} />
      </PaperSheet>
    </PageContent>
  </Page>
);

NewMerchant.propTypes = {
  createMerchant: PropTypes.func.isRequired,
};

export default NewMerchant;
